<template>
  <div>
    <!-- Freight Enq Summary Section Start -->
    <div></div>
    <b-button
      v-if="frt_enq_id > 0"
      class="mb-1 mt-1"
      @click="showEnqModal(frt_enq_id)"
      size="xs"
      style="font-size: 0.675rem"
      >Update Remark</b-button
    >
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      ref="ENQ-modal"
      hide-footer
      :title="Page_title"
    >
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <b-row>
        <b-col md="3">
          <label>Status</label>
          <model-list-select
            :list="StatusList"
            v-model="enq_freight.frt_enq_status"
            option-value="StatusVal"
            option-text="StatusText"
            placeholder="Select Status"
          ></model-list-select>
        </b-col>
        <b-col md="3">
          <label>Tentative Sale Date</label>
          <date-picker
            :format="selectDateFormat"
            lang="en"
            name="frt_enq_tentative_sale_date"
            id="frt_enq_tentative_sale_date"
            placeholder="Enter Tentative Sail Date"
            v-model="enq_freight.frt_enq_tentative_sale_date"
            :not-before="calculateMinDate()"
          ></date-picker>
        </b-col>
        <b-col md="6">
          <label>Remark</label>
          <b-textarea
            :formatter="capitalizeAll"
            v-model="enq_freight.frt_enq_remarks"
            rows="3"
            type="text"
            placeholder="Enter Remark"
          ></b-textarea>
        </b-col>
        <b-col cols="12" class="text-center">
          <b-button
            v-if="
              enq_freight.frt_enq_remarks && enq_freight.frt_enq_status && frt_enq_id > 0
            "
            class="mt-3"
            variant="primary"
            @click="saveEnquiry()"
            id="saveEnquiry"
            >{{ frt_enq_id && frt_enq_id > 0 ? "Update" : "Save" }}</b-button
          >
          <b-button class="mt-3" variant="outline-danger" @click="hideEnqModal"
            >Close</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose"
      ref="addPop"
    ></md-dialog-confirm>
  </div>

  <!-- Freight Enq Summary Section End -->
</template>

<script>
import DatePicker from "vue2-datepicker";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import MasterService from "../../services/MasterService.js";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import CustomLoader from "./customLoader.vue";

export default {
  props: {
    PMC_title: {
      type: String,
      default: "",
    },
    PMC_ENQID: {
      type: String,
      default: "",
    },
    PMC_ENQNO: {
      type: String,
      default: "",
    },
    PMC_ENQDATE: {
      type: String,
      default: "",
    },
    PMC_ENQREMARK: {
      type: String,
      default: "",
    },
    PMC_ENQSTATUS: {
      type: String,
      default: "",
    },
    PMC_ENQTENTATIVESOB: {
      type: String,
      default: "",
    },
  },
  beforeMount() {
    if (this.PMC_ENQID) {
    }
  },
  mounted() {},

  data() {
    return {
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },

      Page_title: this.PMC_title,
      frt_enq_id: this.PMC_ENQID,
      isLoading: false,
      docURL: URL_BASE_DOC,
      enq_freight: {
        frt_enq_id: this.PMC_ENQID,
        frt_enq_no: this.PMC_ENQNO,
        frt_enq_status: this.PMC_ENQSTATUS,
        frt_enq_remarks: this.PMC_ENQREMARK,
        frt_enq_tentative_sale_date: this.PMC_ENQTENTATIVESOB,
      },
      StatusList: [
        {
          StatusVal: "QUOTED",
          StatusText: "QUOTED",
        },
        {
          StatusVal: "REQUESTED",
          StatusText: "REQUESTED",
        },
        {
          StatusVal: "CLOSED",
          StatusText: "CLOSED",
        },
        {
          StatusVal: "QUOTED ON ZIM",
          StatusText: "QUOTED ON ZIM",
        },
      ],
    };
  },
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    Loading,
    DatePicker,
    ModelListSelect,
    CustomLoader,
  },

  computed: {},
  methods: {
    calculateMinDate() {
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const minDate = new Date(today);
      minDate.setMonth(minDate.getMonth());
      return minDate.setDate(now.getDate());
    },
    saveEnquiry(item) {
      let payload = {
        enq_freight: this.enq_freight,
        itemCode: "updateFreightEnqRemarks",
      };
      MasterService.getFreightEnqPriceing(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data.find == 1 && data.flag == true) {
            this.hideEnqModal();
            this.alert.content = data.MSG;
            this.$refs["addPop"].open();
            eventBus.$emit("enqApprovalComp", data);
          }
        })
        .catch((error) => {
          console.log("Catch on getSubItemList Error: ", error);
        });
    },

    showEnqModal(frt_enq_id) {
      this.$refs["ENQ-modal"].show();
      this.isLoading = false;
    },
    hideEnqModal() {
      this.$refs["ENQ-modal"].hide();
      this.isLoading = false;
    },
  },
};
</script>
<style>
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}
.my-custom-scrollbar_xAxis {
  position: relative;
  height: 340px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
</style>



// WEBPACK FOOTER //
// enqCloseStatus.vue?760344c7